import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useState, useCallback } from 'react';
import ConfigProviderContext, { INITIAL_STATE } from './ConfigProviderContext';

var ConfigProvider = function ConfigProvider(_a) {
  var children = _a.children,
      props = __rest(_a, ["children"]);

  var _useState = useState(0),
      downloadBarHeight = _useState[0],
      setHeight = _useState[1];

  var setDownloadBarHeight = useCallback(function (height) {
    setHeight(height);
  }, [setHeight]);
  var config = useMemo(function () {
    return Object.assign(Object.assign(Object.assign({}, INITIAL_STATE), props), {
      downloadBarHeight: downloadBarHeight,
      setDownloadBarHeight: setDownloadBarHeight
    });
  }, [props, downloadBarHeight, setDownloadBarHeight]);
  return _jsx(ConfigProviderContext.Provider, Object.assign({
    value: config
  }, {
    children: children
  }));
};

ConfigProvider.defaultProps = {};
export default ConfigProvider;